import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedUserProfileSetup } from '../components/EnhancedUserProfileSetup';
import { User } from '../types';
import { ROUTES } from '../constants/app';

interface ProfilePageProps {
  currentUser: User;
  onUserUpdate: (updatedUser: User) => void;
  onLogout: () => void;
}

/**
 * VISTA: Página de edición de perfil
 * 
 * Funcionalidades principales:
 * - Editar información del perfil del usuario
 * - Guardar cambios y actualizar estado global
 * - Navegación de regreso a la vista principal
 */
export const ProfilePage: React.FC<ProfilePageProps> = ({ currentUser, onUserUpdate, onLogout }) => {
  const navigate = useNavigate();

  const handleProfileSave = (updatedUser: User) => {
    onUserUpdate(updatedUser);
    navigate(ROUTES.HOME);
  };

  const handleLogout = () => {
    onLogout();
  };
  return (
    <div className="min-h-screen bg-white overflow-y-auto scroll-container" style={{ height: '100vh', overflowY: 'scroll' }}>
      <EnhancedUserProfileSetup 
        onComplete={handleProfileSave}
        initialUserData={currentUser}
        onLogout={handleLogout}
      />
    </div>
  );
};